import "./polyfills/symbolObservable";
import { setLoggingConfig } from "./features/notifications/utils/logger";

// Configure logging once at the application entry point before any components mount.
setLoggingConfig({ enabled: true, level: (import.meta.env.VITE_LOG_LEVEL as "debug" | "info" | "warn" | "error" | "none") || "debug" });

import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { sentinelConfig } from "./config/sentinelConfig";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { Harmony } from "@uhg-harmony/react";
import ErrorBoundary from "./components/ErrorBoundary";

const POST_SIGNIN_PATH = "/";

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <ErrorBoundary>
      <Provider store={store}>
        <AuthProvider
          {...sentinelConfig}
          onSigninCallback={() => {
            window.history.replaceState({}, document.title, POST_SIGNIN_PATH);
          }}
        >
          <Harmony
            appId={import.meta.env.VITE_HARMONY_APP_ID}
            licenseKey={import.meta.env.VITE_HARMONY_LICENSE_KEY}
            spacing
            grid
          >
            <App />
          </Harmony>
        </AuthProvider>
      </Provider>
    </ErrorBoundary>
  );
}
